import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { IconButton } from '@upmc/ims.component-library';
import { useEffect, useState } from 'react';
import WithLoadingHandler from '../../hoc/withLoadingHandler/withLoadingHandler';
import classes from './PendingApprovals.module.scss';

/**
 * React component for displaying legacy page to allow user to accept/reject request.
 * @param {object} props Props for opening and closing the modal.
 * @returns React component.
 */
const ApprovalEmailModal = ({
	navigateUrl,
	approvalEmailOpen,
	setApprovalEmailOpen,
	refreshTable,
}) => {
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => setIsLoading(true), [navigateUrl]);

	const closeModal = () => {
		refreshTable();
		setApprovalEmailOpen(false);
	};

	return (
		<Dialog
			open={approvalEmailOpen}
			onClose={() => closeModal()}
			className={classes.dialog__container}
			maxWidth={false}
		>
			<DialogContent
				sx={{
					width: '70vw',
					height: '95vh',
					padding: '12px 48px 12px 48px',
				}}
			>
				<IconButton
					onClick={() => closeModal()}
					className={classes['icon--float']}
				>
					<CloseIcon />
				</IconButton>
				<WithLoadingHandler isLoading={isLoading}>
					<iframe
						title='Approval Email'
						src={`../${navigateUrl}`}
						onLoad={() => setIsLoading(false)}
						className={isLoading ? classes.loading : ''}
					/>
				</WithLoadingHandler>
			</DialogContent>
		</Dialog>
	);
};

export { ApprovalEmailModal };
